import LocalizedStrings from 'react-localization';

import { getInternalCommonContents, getProgramLanguageContents } from  '../../utils/comms';

// CONFIGURACIÓ IDIOMES DISPONIBLES
const availableLanguages = [
  'ca',
  'es',
  'en'
]; // Idiomes en que està disponible la interfície
const defaultLanguage = 'ca'; // Idioma per defecte en que es mostra la interfície, pot ser qualsevols dels disponibles

// Carregam els fitxers amb els textos comuns per a cada idioma
const languagesArray = availableLanguages.map((lang) => {
  const languageCommonContents = require(`../${lang}/common_web.json`);
  return {[lang]: languageCommonContents}
});
// Convertim l'array d'objectes en un sol objecte
let languagesContents = Object.assign({}, ...languagesArray);

let commonAndInternalLanguages = {};

let translations = new LocalizedStrings(languagesContents);

function changeLang(newLang) {
  lang = newLang;
  translations.setLanguage(lang);
}

function getLang() {
  const browserLanguage = navigator.language;
  const language = browserLanguage.split('-'); // Per si està en format es-ES
  if (language[0] === 'ca' || language[0] === 'es' || language[0] === 'en') return language[0];
  return defaultLanguage;
}

let lang = getLang();
changeLang(lang);

// Carregam les traduccions generiques (noms de programes i formularis) que per seguretat no volem que es vegin si no s'està loguejat
const addInternalCommonContents = async (token) => {
  let internalLanguageCommonContents =  {};  
  try {
    const internalLanguageCommonContentsFromServer = await getInternalCommonContents(token);    
    if(internalLanguageCommonContentsFromServer.status === 200 && internalLanguageCommonContentsFromServer.data.status === 'ok') {
      internalLanguageCommonContents = internalLanguageCommonContentsFromServer.data.languages;
    } else {
      throw 'internalCommonTranslationsNotAvailable';
    }
  } catch (error) {
    throw error;
  }

  // Per a cada idioma, afegim a languagesContents les traduccions genèriques obtingudes del servidor
  const commonAndInternalLanguagesArray = availableLanguages.map((lang) => {    
    const unifiedByLang = Object.assign(languagesContents[lang], internalLanguageCommonContents[lang]);
    return {[lang]: unifiedByLang}    
  });
  // Convertim l'array d'objectes en un sol objecte i el ficam a commonAndInternalLanguages
  commonAndInternalLanguages = Object.assign({}, ...commonAndInternalLanguagesArray);

  translations = new LocalizedStrings(commonAndInternalLanguages);
  changeLang(lang);
}

const addProgramTranslations = async (programId, token) => {      
  // Feim una copia de l'objecte amb els continguts comuns i generics. És necessari fer la còpia profunda per evitar modificar l'objecte original.
  // A la copia de l'objecte amb els continguts comuns i generics s'hi afegeixen els textos específics del programa.
  // Les copies profundes d'objectes es fan amb JSON.parse(JSON.stringify(objecte)) més info: https://developer.mozilla.org/en-US/docs/Glossary/Deep_copy
  const commonAndInternalLanguagesDeepCopy = JSON.parse(JSON.stringify(commonAndInternalLanguages));

  let programLanguageContents =  {};
  try {
    const programLanguageContentsFromServer = await getProgramLanguageContents(programId, token);
    if(programLanguageContentsFromServer.status === 200 && programLanguageContentsFromServer.data.status === 'ok') {      
      programLanguageContents = programLanguageContentsFromServer.data.languages;
    } else {
      throw 'programLanguageTranslationsNotAvailable';
    }
  } catch (error) {
    throw error;
  }
  
  // Per a cada idioma, afegim a languagesContents les traduccions genèriques obtingudes del servidor
  const commonAndInternalAndProgramLanguagesArray = availableLanguages.map((lang) => {
    let unifiedByLang = {}
    // Si no existeix commonAndInternalLanguagesDeepCopy[lang] vol dir que s'ha recarregat el navegador i no s'ha passat per addInternalCommonContents.
    // En aquest cas només carregam les traduccions comuns i les del programa
    if (commonAndInternalLanguagesDeepCopy[lang]) {
      unifiedByLang = Object.assign(commonAndInternalLanguagesDeepCopy[lang], programLanguageContents[lang]);
    } else {
      unifiedByLang = Object.assign(languagesContents[lang], programLanguageContents[lang]);
    }
    return {[lang]: unifiedByLang}    
  });

  // Convertim l'array d'objectes en un sol objecte
  const commonAndInternalAndProgramLanguages = Object.assign({}, ...commonAndInternalAndProgramLanguagesArray);
  translations = new LocalizedStrings(commonAndInternalAndProgramLanguages);
  changeLang(lang);
}

export { translations as default};

export { availableLanguages, changeLang, defaultLanguage, getLang, addInternalCommonContents, addProgramTranslations };
